<template>
<div id="etips" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Manual de Usuario" class="elevation-1 px-5 py-3" >
                    <v-card-actions style="margin-top:-50px;" >
                      
                        <v-spacer></v-spacer>
                        <v-btn small outlined color="red" @click="generaPDF" title="Exportar a PDF"  >
                            <v-icon>mdi-file-pdf-box</v-icon>

                        </v-btn>
                        <v-btn v-if="superusuario" small outlined color="blue" @click="saveDocx" title="Exportar a Word" >
                            <v-icon>mdi-file-word-box</v-icon>

                        </v-btn>
                    </v-card-actions>
                    <v-card-text>
                        <v-row>
                            <v-col cols="3" style=" height:auto;   background-color: white;" >
                                 
                             <!-- <v-text-field  v-model="search" label="Buscar"  clear-icon="mdi-close-circle-outline" ></v-text-field>     -->
                             <!-- <v-navigation-drawer permanent left  style="z-index:0 !important; margin-top: -6px; height:450px;" >
                               <v-list dense class="pt-0 " > 
                                        <v-list-item v-for="(item, index) in filteredList"  @click="cargarOne(item.id)" 
                                            :key="index"  >                
                                            <v-list-item-content>
                                                - {{ item.nombre }}
                                            </v-list-item-content>
                                        </v-list-item>
                                   
                                </v-list>
                            </v-navigation-drawer> -->
                            
                                <v-navigation-drawer permanent left  style="z-index:0 !important; margin-top: -6px; height: 750px; width:350px !important;" >
                                 
                                  
                                    <br/>
                                     <v-sheet class="pa-5" >
                                        <v-switch v-if="!es_transportista && !soloCartaPorte"
                                       v-model="isAdmin"
                                        label="Manual del Cliente"
                                         inset
                                        ></v-switch>
                                      
                                    </v-sheet>
                                    <v-list dense class="pt-0 " > 
                                        
                                        <v-list-group v-for="(grupo, index) in grupos" :key="'grupo'+index"
                                            v-show="getItemsGrupo(grupo.id).length > 0"
                                            no-action :prepend-icon="grupo.icon" :value="grupo.id==grupoActivo" >
                                            <template v-slot:activator>
                                                <v-list-item-title>{{grupo.nombre}}</v-list-item-title>
                                            </template>
                                            
                                            <v-list-item v-for="(item, index2) in getItemsGrupo(grupo.id)" :key="index2" @click="cargarOne(item.id)" 
                                                :class=" {'#e0e0e0 secondary lighten-1': selected ==item.id}" >    
                                                                
                                                <v-list-item-content>
                                                    - {{ item.nombre }}
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-group>
                                    </v-list>
                                    
                                </v-navigation-drawer>
                         <!--     <ul id="example-1" >
                                    <li v-for="(item, index) in filteredList" :key="index" >
                                        <a href="#" @click="cargarOne(item.id)" >
                                            {{ item.nombre }}
                                        </a>
                                    </li>
                                </ul> -->

                            </v-col>

                            <v-col id="contenedor" class="d-flex" style="height:auto; overflow-y:auto;  background-color: white;" >

                                <div id="htmlSource" class="manual" >
                                    <meta charset="utf-8" >
                                    
                                    <div v-for="(item, index) in etip" :key="index" :id="'menu-' + index" >
                                        <div v-if="item.tab1== 1 || item.tab2== 1 || item.tab3== 1 " >
                                            <h3  >{{ item.nombre }}</h3>
                                            <h4>{{ item.subtitulo }}</h4>
                                            <div v-if="item.tab1== 1 " >
                                                <h5>{{ item.tab1_titulo }}</h5>
                                                <div class="global" v-html="item.tab1_contenido" :key="index + 1000" />
                                            </div>
                                            <div v-if="item.tab2== 1 " >
                                                <h5>{{ item.tab2_titulo }}</h5>
                                                <br />
                                                <div class="global" v-html="item.tab2_contenido" :key="index + 2000" />

                                            </div>
                                            <div v-if="item.tab3== 1 " >
                                                <h5>{{ item.tab3_titulo }}</h5>
                                                <br />
                                                <div class="global" v-html="item.tab3_contenido" :key="index + 3000" />

                                            </div>
                                            <h5 style="page-break-before: always; color:white;" >.</h5>
                                           
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>



<script lang="en" >
import axios from "axios";
//import html2pdf from "html2pdf.js";
import jsPDF from "jspdf"
import html2canvas from "html2canvas"
import Vue from 'vue'
import { mapMutations, mapState } from 'vuex'
import {
    asBlob
} from 'html-docx-js-typescript'
// if you want to save the docx file, you need import 'file-saver'
import {
    saveAs
} from 'file-saver'

export default {
   
    data: () => ({

isAdmin: true,
 grupos: [
            {id:'Panel Principal', nombre: 'Panel Principal', icon:'menu_book'},
            {id:'Usuarios', nombre: 'Usuarios', icon:'menu_book'},
            {id:'Cobranza', nombre: 'Cobranza', icon:'menu_book'},
            {id:'Contenido Normativo', nombre: 'Contenido Normativo', icon:'menu_book'},
            {id:'Catálogos', nombre: 'Catálogos', icon:'menu_book'},
            {id:'Preguntas', nombre: 'Preguntas', icon:'menu_book'},
            {id:'Utilerias', nombre: 'Utilerias', icon:'menu_book'},
            {id:'VUCEM-Transmisión', nombre: 'VUCEM-Transmisión', icon:'menu_book'},
            {id:'Data Stage', nombre: 'Data Stage', icon:'menu_book'},
            {id:'Vucem-Pedimento', nombre: 'Vucem-Pedimento', icon:'menu_book'},
            {id:'eDRIVE', nombre: 'eDRIVE', icon:'menu_book'},
            {id:'Indicadores EEA', nombre: 'Indicadores EEA', icon:'menu_book'},
            {id:'eManifiesto-CCP', nombre: 'eManifiesto-CCP', icon:'menu_book'},
            {id:'Crear Documento', nombre: 'Crear Documento', icon:'menu_book'},
            {id:'Reportes', nombre: 'Reportes', icon:'menu_book'},
            {id:'Gestión de Embarques', nombre: 'Gestión de Embarques', icon:'menu_book'},
            {id:'Bandeja Expediente Entrante', nombre: 'Bandeja Expediente Entrante', icon:'menu_book'},            
        
            
            {id:'SuperUsuario-MxTransmite', nombre: 'SuperUsuario-MxTransmite', icon:'menu_book'},
            
            
           
            
            
            
           

        ],
        ocultar: [ 'Usuarios SA31', 'Apendices SA31' ],
        grupoActivo: "Administración",
        fab: false,
        selected : "",
        URL: "",
        etips: [],
        etip: [],
        show_loading: true,
        title_catalogo: "Manual de Usuario",
        columnDefs: null,
        rowData: null,
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/admin"
            },
            {
                text: "Manual de Usuario",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        search: "",

    }),
    computed: mapState({
        superusuario() {
            return this.$local_storage.get("tipo_usuario") == "Super Usuario";
        },
        cliente() {
            return this.$local_storage.get("tipo_usuario") == "Grupo" || this.$local_storage.get("tipo_usuario") == "Cliente";
            
        },
        filteredList() {
            return this.etips.filter(tip => {
                return tip.nombre.toLowerCase().includes(this.search.toLowerCase())
            })
        },
        es_transportista() {
            return this.$local_storage.get("es_transportista")==1 ;
        },
       
        soloCartaPorte(){
            return (this.$local_storage.get("soloCartaPorte") == 100);
        },
    }),
    methods: {
         getItemsGrupo: function(idGrupo){         
             let self = this;   
             var filtro = [];
             if(self.cliente || self.isAdmin){
                 filtro = this.filteredList.filter(function(item){
                    return item.categoria == idGrupo 
                    && (item.tab1_contenido || item.tab2_contenido || item.tab3_contenido || item.tab4_contenido) 
                    && (item.tab1==1 || item.tab2==1 || item.tab3==1 || item.tab4==1 )
                    && item.modulo !='SUPER' && !self.ocultar.includes(item.nombre) ;
                    });
             }else{
                     filtro = this.filteredList.filter(function(item){
                    return item.categoria == idGrupo 
                    && (item.tab1_contenido || item.tab2_contenido || item.tab3_contenido || item.tab4_contenido) 
                    && (item.tab1==1 || item.tab2==1 || item.tab3==1 || item.tab4==1 )
                    && item.modulo =='SUPER' && !self.ocultar.includes(item.nombre) ;
                    });
             }
             
              filtro = filtro.sort(function (a, b) {
                    if (a.orden > b.orden) {
                        return 1;
                    }
                    if (a.orden < b.orden) {
                        return -1;
                    }            
                    return 0;
                });      

            return filtro;
        },
        async saveDocx() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let htmlString = document.getElementById("htmlSource").innerHTML;

            htmlString = `<!DOCTYPE html>
                        <html lang="en" >
                        <head><meta charset="UTF-8" >
                            <title>Manual de Usuario</title>
                        </head>
                        <body>` + htmlString + `</body>
                        </html>`;
            const fileData = await asBlob(htmlString) // asBlob() return Promise<Blob|Buffer>
            saveAs(fileData, 'Manual de Usuario.docx') // save as docx file
            this.$root.$dialogLoader.hide();
        },
     
        cargar: function () {
            axios
                .post(this.URL + "configuracion/etips/get_titulos/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.etips = res.data;
                        if(this.es_transportista || this.soloCartaPorte ){
                             this.etips = res.data.filter(e => {
                                    return e.modulo == "eManifiesto-CCP";
                            });
                        }
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los registros.",
                        footer: ""
                    });
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },
         cargarOne: function (id) {
              this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
             this.etip = [];
             this.selected = id;
            axios
                .get(this.URL + "configuracion/etips/" + id)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.etip.push(res.data);
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los registros.",
                        footer: ""
                    });
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },
        generaPDF() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var pdf = new jsPDF('p', 'pt', 'letter');
            // source can be HTML-formatted string, or a reference
            // to an actual DOM element from which the text will be scraped.
            let source = document.getElementById("htmlSource").innerHTML;
            
            
          //  source = source.replace(/['”]+/g, '');  
          //  source = source.replace(/['“]+/g, ''); 
          //  source = source.split('ql-align-justify').join('');
        //    source = source.split('&nbsp;').join(''); 
         //   source = source.replace(/\n|\r/g, "");
          //  source = source.replace(/[^\x20-\x7E]/gmi, "");
          source = source.split('”').join(' '); 
          source = source.split('“').join(' '); 
          source = source.split('’').join(' '); 
          // source = source.replace(/[\x5E]/g, "");
            //source = source.replace(/[^\x20-\x7E]/gmi, "");
            // we support special element handlers. Register them with jQuery-style 
            // ID selector for either ID or node name. ("#iAmID", "div", "span" etc.)
            // There is no support for any other type of selectors 
            // (class, of compound) at this time.
            let specialElementHandlers = {
                '#bypassme': function (element, renderer) {
                    return true
                }
            };
            let margins = {
                top: 60,
                bottom: 60,
                left: 60,
                width: 480
            };
            // all coords and widths are in jsPDF instance's declared units
            // 'inches' in this case
            var thisObj = this;
            pdf.fromHTML(
                source, // HTML string or DOM elem ref.
                margins.left, // x coord
                margins.top, { // y coord
                    'width': margins.width, // max width of content on PDF
                    'elementHandlers': specialElementHandlers
                },

                function (dispose) {
                    // dispose: object with X, Y of the last line add to the PDF 
                    //          this allow the insertion of new lines after html
                    pdf.save('Manual de Usuario.pdf');
                    thisObj.$root.$dialogLoader.hide();
                }, margins);                

        },
        generaPDF2:  function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let html = document.getElementById("htmlSource").innerHTML;
            var opt = {
                margin: 1, //top, left, bottom, right
                filename: "Manual de Usuario.pdf",
                image: {
                    type: "jpeg",
                    quality: 0.98
                },
                html2canvas: {
                    scale: 0.9,
                },
                jsPDF:{ unit: 'cm', format: 'a4', orientation: 'p' }
            };
            var thisObj = this;
            html2pdf()
                .set(opt)
                .from(html)
                .toPdf().get('pdf')
                .then(function (pdf) {
                    var totalPages = pdf.internal.getNumberOfPages();
/* 
                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i`);
                        pdf.setFontSize(10);
                        pdf.setTextColor(150);
                        pdf.text("Econnect ProControl - Manual de Usuario ", pdf.internal.pageSize.getWidth() - 3.2, .8);
                        pdf.text('_________________________________________________________________________________________________', .5, .85);
                        pdf.text("" + i, pdf.internal.pageSize.getWidth() - .6, pdf.internal.pageSize.getHeight() - 1.1);
                    } */
                    thisObj.$root.$dialogLoader.hide();
                })
                .save();

        }
    }, //methods
    mounted: function () {
        this.URL = this.$hostname;
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
         if (this.$local_storage.get("id_cliente")  >0 ) {
            this.breadcrumbs[0].to = "/home";
        } else {
            this.breadcrumbs[0].to = "/admin";
        }
         if (this.$store.state.carta_porte == 1 || this.$local_storage.get("es_transportista")==1) {
            this.breadcrumbs= [{
                        text: "Inicio",
                        disabled: false,
                        to: "/indext"
                    },
                    {
                        text: "Manual de Usuario",
                        disabled: true,
                        href: ""
                    }
                ]
       }
        this.cargar();
        //this.cargarOne(1);
    }
};
</script>

<style scoped>
.global {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
    font-size: small;
}

.manual {
    margin: 0px;
    padding: 0px;
    height: auto;
    width: auto;
    background: #fff;
    text-align: justify;
    font-family: Arial, sans-serif;
}

h3 {
    font-family: Arial, sans-serif;
    color: navy;
    font-size: x-large;
    font-weight: bold;

}

h4 {
    font-family: Arial, sans-serif;
    font-size: medium;
    font-weight: bold;
    margin-left: 20px;
    font-style: italic;
    color: gray;
}

h5 {
    font-family: Arial, sans-serif;
    font-size: small;
    margin-left: 20px;
    font-weight: bold;
}
</style>
